import BufferShim from "buffer";

export const Buffer = BufferShim.Buffer;

if (process.env.NODE_ENV === "development") {
  // Must use require here as import statements are only allowed
  // to exist at top-level.
  // DISABLED because the warnings are not relevant to us.
  // require("preact/debug");
}

// Useful for debugging MutationObserver as it does not give
// useful stack traces...
if (
  typeof MutationObserver !== "undefined" &&
  typeof document.body.nodeType === Node.ELEMENT_NODE // eslint-disable-line no-restricted-properties
) {
  const obs = MutationObserver.prototype.observe;
  MutationObserver.prototype.observe = function () {
    const [el] = arguments;
    if (el?.nodeType !== Node.ELEMENT_NODE) {
      const error = new Error(
        `Invalid call to observe, got "${el}" (type: ${typeof el}). ${
          new Error().stack
        }`,
      );
      throw error;
    }
    return obs.apply(this, arguments);
  };
}
